/* eslint-disable no-console */
const levels = { error: 0, info: 1, debug: 2 };
const NO_ABBA_CLEAR_STORAGE_FN = "No function to clear abba storage specified. Storage may not have been flushed correctly";
const noClearAbbaStorageWarning = () => console.warn(NO_ABBA_CLEAR_STORAGE_FN);

export class DebugTools {
    enabled = false;
    usePopup = true;

    _init(forcedLogLevel = null, suppressDebugPopup = false) {
        try {
            if (this.enabled) {
                throw new Error("DebugTools already initialized and enabled. Initialization aborted.");
            }

            if (forcedLogLevel) {
                this.loggerLevel = forcedLogLevel;
            } else {
                this._getLoggerLevel();
            }

            if (levels[this.loggerLevel] == null) {
                if (this.loggerLevel && !this.loggedError) {
                    const invalidLoggerLevelMsg = `Invalid logger level provided to query param: ${ this.loggerLevel }.
                                Valid logger levels: ${ Object.keys(levels).join(", ") }`;

                    throw new Error(invalidLoggerLevelMsg);
                }

                return;
            }

            if (suppressDebugPopup) {
                this.usePopup = false;
            } else {
                this._createLoggerPopup();
            }

            this.enabled = true;
        } catch (e) {
            console.error(e);
            this.loggedError = true;
        }
    }

    _getLoggerLevel() {
        const urlParams = new URLSearchParams(window?.location?.search ?? "");

        this.loggerLevel = urlParams.get("abbaLog");
    }

    _createLoggerPopup() {
        if (!document?.body) {
            throw new Error("Document not ready for popup. Failed to init DebugTools.");
        }

        this.abbaPopout = document.createElement("div");
        this.abbaPopout.setAttribute(
            "style",
            "all:unset;position:fixed;top:40px;left:0;width:300px;max-height:500px;overflow:auto;background-color:white;border:2px solid black;z-index:999999;overflow-wrap:break-word;font-family:monospace;font-size:11px"
        );
        document.body.appendChild(this.abbaPopout);

        const toggleButton = document.createElement("button");

        toggleButton.appendChild(document.createTextNode("Abba Debug - Click here to Show/Hide"));
        toggleButton.setAttribute(
            "style",
            "all:unset;position:fixed;top:0;left:0;height:20px;background-color:black;color:white;font-family:monospace;cursor:pointer;padding:2px;width:300px;font-size:13px;z-index:999999;"
        );
        toggleButton.onclick = function () {
            this.abbaPopout.style.display = this.abbaPopout.style.display === "none" ? "block" : "none";
        }.bind(this);

        const resetButton = document.createElement("button");

        resetButton.appendChild(document.createTextNode("Click here to clear ABBA storage"));
        resetButton.setAttribute(
            "style",
            "all:unset;position:fixed;top:20px;left:0;height:20px;background-color:white;color:black;font-family:monospace;cursor:pointer;border:2px inset black;width:300px;font-size:13px;z-index:999999;"
        );

        resetButton.onclick = () => this.clearAbbaStorage?.() ?? noClearAbbaStorageWarning();

        document.body.appendChild(resetButton);
        document.body.appendChild(toggleButton);
    }

    setClearAbbaStorage(clearAbbaStorage) {
        this.clearAbbaStorage = typeof clearAbbaStorage === "function"
            ? clearAbbaStorage : noClearAbbaStorageWarning;
    }

    info(msg, obj) {
        this._log("info", msg, obj);
    }
    debug(msg, obj) {
        this._log("debug", msg, obj);
    }
    error(msg, obj) {
        this._log("error", msg, obj);
    }

    _log(level = "info", msg, obj) {
        if (!this.enabled) {
            this._init();
        }

        if (this.enabled && this.loggerLevel && levels[this.loggerLevel] >= levels[level]) {
            console.log(`[ABBA] ${ msg }`, obj);
            this.addMessage(`[${ level.toUpperCase() }] ${ msg } ${ obj ? "(check console)" : "" }`, level);
        }
    }

    addMessage(message, level) {
        if (!this.enabled) {
            console.error("DebugTools not enabled. Cannot add message.");

            return;
        }

        if (!this.usePopup) {
            return;
        }

        const textNode = document.createElement("div");
        const text = document.createTextNode(message);

        if (level === "error") {
            textNode.setAttribute("style", "background-color:red;color:white");
        } else if (level === "info") {
            textNode.setAttribute("style", "background-color:blue;color:white");
        }

        textNode.appendChild(text);
        this.abbaPopout.appendChild(textNode);
    }
}

export default new DebugTools();
